"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blacklistValidator = {
    name: 'blacklist',
    validation: function (value, element, config) {
        if (config.values) {
            var blacklistValues = [].concat(config.values);
            return !blacklistValues.map(function (blacklistValue) { return String(blacklistValue); }).includes(value);
        }
        else {
            throw new Error('config.exclude must have values');
        }
    },
};
//# sourceMappingURL=BlacklistValidator.js.map